import moment from 'moment';
import MenuRightSerivce from "@/service/MenuRightService";
import InviteNewCandidateService from "@/service/InviteNewCandidateService";
import JobAdsService from "@/service/JobAdsService";
import StaffService from "@/service/StaffService";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import { CandidateInvited } from "@/model/CandidateInvited";
import { Attachment } from "@/model/Attachment";
import { Staff } from "@/model/Staff";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import DatePicker from "vue2-datepicker";
import Paginate from "vuejs-paginate";
import inviteNewCandidateValidatonObj from "./S090200-InviteNewCandidateValidaton.js";
import Settings from '../../../constants/Settings.js';
var inviteNewCandidateDataValidatonObj = new inviteNewCandidateValidatonObj();
export default {
  name: "InviteNewCandidate",
  components: {
    DatePicker, paginate: Paginate,
  },
  mounted() {
    this.init();
    this.scrollContent();
    inviteNewCandidateDataValidatonObj.inviteNewCandidateValidaton();
    this.assignRights();
    this.getCandidateInvitedList();
    this.getJobadListForCandidatesInvited();
  },
  data: () => ({
    menuRights: { allRights: {}, rightsForThisMenu: {} },
    menuId: Settings.MenuID.NewCandidate,
    Settings: Settings,
    dictEnum: dictEnum,
    candidateInvited: new CandidateInvited(),
    isEditMode: false,
    candidateInvitedList: [],
    jobAdList: [],
    historyList: [],
    selectAllEmployType: false,
    tab1: null,
    tabItems: [
      { tab1: 'One', content: 'Tab 1 Content' },
      { tab1: 'Two', content: 'Tab 2 Content' },
    ],
    selectedCompany: "",
    date: new Date(),
    min: new Date(),
    max: new Date(),
    type: 'date',
    companyEngName: "",
    companyChiName: "",
    isLoaded: true,
    jobName: "",
    interviewerName: "",
    time1: false,
    time2: false,
    time3: false,
    historySearchModel: {
      name: "",
      mobile: "",
      dob: "",
      keywords: ""
    },
    selectAllTimes: false,
    selectedDateTime1: false,
    selectedDateTime2: false,
    selectedDateTime3: false,
    optionList: [],
    userExist: false,
    existingUserId: '',
    attachment: new Attachment(),
    IsMenuActive: false,
    dob: "",
    staffList: [],
    staff: new Staff(),
    take: 10,
    skip: 0,
    totalNoOfPages: 0,
    noOfPages: 5,
    currentSelectedPage: 0,
    currentPage: this.currentSelectedPage + 1,
    totalRecords: 0,
  }),
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
    formattedDate() {
      return this.date &&
        moment(this.date).format('YYYY-MM-DD') != '1900-01-01'
        ? moment(this.date).format('YYYY-MM-DD')
        : undefined;
    },
  },
  watch: {
    companyEngName: function () {
      this.isLoaded = false;
      this.isLoaded = true;
    }
  },
  methods: {
    init() {
      var self = this;
      var documentHeight = $(document).height();
      var headerHeight = $("nav").height();
      var candHeight = $(".cand-head").height();
      var tableHeaderHeight = $("table thead").height();
      var pagginationHeight = $(".paggination-cand").height();
      var docHeight = documentHeight != undefined ? documentHeight : 666;
      var headHeight = headerHeight != undefined ? headerHeight : 59;
      var candHeadHeight = candHeight != undefined ? candHeight : 34;
      var tHeadHeight = tableHeaderHeight != undefined && tableHeaderHeight != 0 ? tableHeaderHeight : 52;
      var paggHeight = pagginationHeight != undefined && pagginationHeight != 0 ? pagginationHeight : 22;
      var tableHeight = docHeight - headHeight - candHeadHeight - tHeadHeight - paggHeight - 60;
      self.take = Number((tableHeight / 47).toFixed());
    },
    scrollContent: function () {
      $(".body-scroll-area").mCustomScrollbar({
        theme: "dark",
        scrollInertia: 60,
        scrollbarPosition: "inside",
        axis: "y"
      });
    },
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    async getCandidateInvitedList() {
      var self = this;
      const obj = {
        take: self.take,
        skip: self.skip
      };
      const response = await InviteNewCandidateService.getCandidateInvitedList(obj);
      if (response.data.IsSuccess) {
        self.candidateInvitedList = response.data.Data.Item1;
        self.candidateInvitedList.forEach(element => {
          if (element.DateAdd != null && element.DateAdd != "") {
            element.DateAdd = moment(element.DateAdd).format("YYYY-MM-DD");
          }
          element.IsEditMode = false;
        });
        self.totalRecords = response.data.Data.Item2;
        self.totalPages();
        if (response.data.Data.Item1.length == 0 && response.data.Data.Item2 > 0) {
          self.changePage(self.currentPage - 1);
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getJobadListForCandidatesInvited() {
      const obj = {};
      const response = await JobAdsService.getJobadListForCandidates(obj);
      if (response.data.IsSuccess) {
        this.jobAdList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getExistingStaff() {
      var self = this;
      if (self.dob == '' || self.dob == undefined || self.dob == null) {
        self.candidateInvited.StaffModel.DOB = '';
      }
      else {
        self.candidateInvited.StaffModel.DOB = self.dob;
      }
      if (self.candidateInvited.StaffModel.EngName == '' || self.candidateInvited.StaffModel.Mobile == '' || self.candidateInvited.StaffModel.DOB == '' || self.candidateInvited.StaffModel.Email == '') {
        return;
      }
      if (self.candidateInvited.JobAdCode == '') {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectJobAd));
        return;
      }
      self.userExist = false;
      const obj = {
        name: self.candidateInvited.StaffModel.EngName,
        mobile: self.candidateInvited.StaffModel.Mobile,
        email: self.candidateInvited.StaffModel.Email,
        dob: self.candidateInvited.StaffModel.DOB
      };
      const response = await StaffService.getStaffByNameMobileEmailAndDob(obj);
      if (response.data.IsSuccess) {
        if (response.data.Data.length > 0) {
          self.userExist = true;
          self.staffList = response.data.Data;
          self.existingUserId = "";
          self.staff = new Staff();
          $("#staffExist").modal("show");
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    onStaffSelect: function (item) {
      var self = this;
      self.existingUserId = item.StaffID;
      self.staff = item;
    },
    async onUserSelectExistOption() {
      var self = this;
      if (self.candidateInvited.JobAdCode == '') {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectJobAd));
        return;
      }
      if (self.existingUserId == '') {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectCandidate));
        return;
      }
      const obj = {
        candId: self.existingUserId,
        jobAdCode: self.candidateInvited.JobAdCode
      };
      const response = await InviteNewCandidateService.getCandidateDetailByCandIdAndJobAdcode(obj);
      if (response.data.IsSuccess) {
        if (response.data.Data != null) {
          SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_CandidateExist));
        }
        else {
          self.candidateInvited.UsedExisting = true;
          self.candidateInvited.CandID = self.existingUserId;
          self.candidateInvited.StaffModel.EngName = self.staff.EngName;
          self.candidateInvited.StaffModel.Mobile = self.staff.Mobile;
          self.dob = moment(self.staff.DOB).format("YYYY-MM-DD");
          $("#staffExist").modal("hide");
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    onUserSelectNewOption: function () {
      var self = this;
      self.candidateInvited.UsedExisting = false;
      $("#staffExist").modal("hide");
    },
    async getStaffHistoryList() {
      const obj = this.historySearchModel;
      const response = await StaffService.getStaffByNameMobileKeyWordsAndDob(obj);
      if (response.data.IsSuccess) {
        this.historyList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
      $("#history").modal("show");
    },
    clearFilter() {
      this.historySearchModel = {
        name: "",
        mobile: "",
        dob: "",
        keywords: ""
      }
      this.getStaffHistoryList();
    },
    async getByCompanCode() {
      const obj = {};
      var self = this;
      self.jobAdList.forEach(function (val, index) {
        if (self.candidateInvited.JobAdCode == val.JobAdCode) {
          obj.companyCode = val.CompCode;
          self.candidateInvited.CompCode = val.CompCode;
          self.jobName = self.user.Lang == 'EN' ? val.JobEDesc : val.JobCDesc;
          self.interviewerName = self.user.Lang == 'EN' ? val.UserEName : val.UserCName;
        }
      });
      if (obj.companyCode != undefined && obj.companyCode != null) {
        const response = await StaffService.getByCompanCode(obj);
        if (response.data.IsSuccess) {
          self.companyEngName = response.data.Data.EName;
          self.companyChiName = response.data.Data.CName;
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      }
    },
    onSelectAll: function () {
      var self = this;
      var IsSelected = self.selectAllTimes;
      if (IsSelected) {
        this.selectedDateTime1 = true;
        this.selectedDateTime2 = true;
        this.selectedDateTime3 = true;
      }
    },
    onOptDeleteButtonClick: function () {
      var self = this;
      var seq = 1;
      var newList = self.optionList.filter(function (val, index) {
        return !val.IsSelected
      })
      newList.forEach(function (val, index) {
        val.Seq = seq;
        seq++;
      });
      self.optionList = newList;
    },
    onOptAddButtonClick: function () {
      var self = this;
      if (self.optionList.length > 2) {
        return;
      }
      var model = {
        IsSelected: false,
        Seq: self.optionList.length + 1,
        OptDate: '',
        OptTime: '',
        time: false,
        IsMenuActive: false,
        ref: "time" + (self.optionList.length + 1)
      }
      self.optionList.push(model);
    },
    deleteMultipleEmployeeTypePopup: function () {
      var arrayList = [];
      var self = this;
      self.employTypeList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      if (arrayList.length > 0) {
        $('#deleteEmployeeType').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectDeleteRecord));
      }
    },
    async deleteMultipleEmployeeType() {
      var arrayList = [];
      var self = this;
      $('#deleteEmployeeType').modal('hide');
      self.employTypeList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      const obj = {
        employeeTypeList: arrayList,
      };
      const response = await EmployTypeService.deleteEmployType(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetEmployTypeData();
        await self.getAllEmployTypes();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getCandidateInvitationDetail(candId, jobAdCode, seq) {
      var self = this;
      const obj = {
        candId: candId,
        jobAdCode: jobAdCode,
        seq: seq,
      };
      self.optionList = [];
      const response = await InviteNewCandidateService.getCandidateInvitedByCandIdAndJobAdcode(obj);
      if (response.data.IsSuccess) {
        self.candidateInvited = response.data.Data;
        self.companyEngName = self.candidateInvited.CompanyEngName;
        self.companyChiName = self.candidateInvited.CompanyChiName;
        self.dob = self.candidateInvited.StaffModel.DOB;
        self.jobAdList.forEach(function (val, index) {
          if (self.candidateInvited.JobAdCode == val.JobAdCode) {
            self.jobName = self.user.Lang == 'EN' ? val.JobEDesc : val.JobCDesc;
            self.interviewerName = self.user.Lang == 'EN' ? val.UserEName : val.UserCName;
          }
        });
        self.candidateInvited.Opt1Date = self.candidateInvited.Opt1 != '1900-01-01' ? self.candidateInvited.Opt1 : '';
        self.candidateInvited.Opt2Date = self.candidateInvited.Opt2 != '1900-01-01' ? self.candidateInvited.Opt2 : '';
        self.candidateInvited.Opt3Date = self.candidateInvited.Opt3 != '1900-01-01' ? self.candidateInvited.Opt3 : '';
        self.candidateInvited.Opt1Time = moment(self.candidateInvited.Opt1).format("HH:mm");
        self.candidateInvited.Opt2Time = moment(self.candidateInvited.Opt2).format("HH:mm");
        self.candidateInvited.Opt3Time = moment(self.candidateInvited.Opt3).format("HH:mm");

        if (self.candidateInvited.Opt1Date != "1900-01-01 00:00" && self.candidateInvited.Opt1Date != '') {
          var model = {
            IsSelected: false,
            Seq: 1,
            OptDate: moment(self.candidateInvited.Opt1Date).format("YYYY-MM-DD"),
            OptTime: self.candidateInvited.Opt1Time,
            time: false,
            IsMenuActive: false,
            ref: "time1"
          }
          self.optionList.push(model);
        }
        if (self.candidateInvited.Opt2Date != "1900-01-01 00:00" && self.candidateInvited.Opt2Date != '') {
          var model = {
            IsSelected: false,
            Seq: 2,
            OptDate: moment(self.candidateInvited.Opt2Date).format("YYYY-MM-DD"),
            OptTime: self.candidateInvited.Opt2Time,
            time: false,
            IsMenuActive: false,
            ref: "time2"
          }
          self.optionList.push(model);
        }
        if (self.candidateInvited.Opt3Date != "1900-01-01 00:00" && self.candidateInvited.Opt3Date != '') {
          var model = {
            IsSelected: false,
            Seq: 3,
            OptDate: moment(self.candidateInvited.Opt3Date).format("YYYY-MM-DD"),
            OptTime: self.candidateInvited.Opt3Time,
            time: false,
            IsMenuActive: false,
            ref: "time3"
          }
          self.optionList.push(model);
        }


        self.candidateInvited.IsNew = false;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async saveInvitationData() {
      var self = this;
      if (!this.isEditMode && !this.candidateInvited.IsNew) {
        return;
      }
      self.$validator.validateAll().then(result => {
        if (result) {
          if (self.optionList.length <= 0) {
            SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_AddOption));
            return;
          }
          if (self.optionList.length == 1) {
            self.candidateInvited.Opt2 = "1900-01-01 00:00";
            self.candidateInvited.Opt3 = "1900-01-01 00:00";
          }
          if (self.optionList.length == 2) {
            self.candidateInvited.Opt3 = "1900-01-01 00:00";
          }
          self.optionList.forEach(function (val, index) {
            if (index == 0) {
              if (val.OptDate != undefined && val.OptDate != '1900-01-01') {
                var newDate = moment(val.OptDate).format("YYYY-MM-DD");//new Date(self.candidateInvited.Opt1Date);
                self.candidateInvited.Opt1 = newDate + " " + val.OptTime; // moment(new Date(year,month,date,hour,minutes)).format("YYYY-MM-DD HH:mm");
              }
            }
            if (index == 1) {
              if (val.OptDate != undefined && val.OptDate != '1900-01-01') {
                var newDate = moment(val.OptDate).format("YYYY-MM-DD");//new Date(self.candidateInvited.Opt1Date);
                self.candidateInvited.Opt2 = newDate + " " + val.OptTime; // moment(new Date(year,month,date,hour,minutes)).format("YYYY-MM-DD HH:mm");
              }
            }
            if (index == 2) {
              if (val.OptDate != undefined && val.OptDate != '1900-01-01') {
                var newDate = moment(val.OptDate).format("YYYY-MM-DD");//new Date(self.candidateInvited.Opt1Date);
                self.candidateInvited.Opt3 = newDate + " " + val.OptTime; // moment(new Date(year,month,date,hour,minutes)).format("YYYY-MM-DD HH:mm");
              }
            }
          });

          // if(self.candidateInvited.Opt1Date != undefined && self.candidateInvited.Opt2Date != '1900-01-01'){
          //   var newDate = moment(self.candidateInvited.Opt1Date).format("YYYY-MM-DD");//new Date(self.candidateInvited.Opt1Date);
          //   self.candidateInvited.Opt1 = newDate + " " + self.candidateInvited.Opt1Time; // moment(new Date(year,month,date,hour,minutes)).format("YYYY-MM-DD HH:mm");
          // }
          // if(self.candidateInvited.Opt2Date == undefined && self.candidateInvited.Opt2Date != '1900-01-01'){
          //   var newDate = moment(self.candidateInvited.Opt2Date).format("YYYY-MM-DD");
          //   self.candidateInvited.Opt2 =  newDate + " " + self.candidateInvited.Opt2Time;
          // }
          // if(self.candidateInvited.Opt3Date != undefined && self.candidateInvited.Opt3Date != '1900-01-01'){
          //   var newDate = moment(self.candidateInvited.Opt3Date).format("YYYY-MM-DD");
          //   self.candidateInvited.Opt3 =   newDate + " " + self.candidateInvited.Opt3Time;
          // }
          if (self.dob != '' && self.dob != undefined && self.dob != null) {
            self.dob = self.candidateInvited.StaffModel.DOB;
          }
          else {
            self.candidateInvited.StaffModel.DOB = moment(self.dob).format("YYYY-MM-DD");
          }
          self.candidateInvited.AddBy = self.$store.getters[StoreGetter.user].UserID;
          self.candidateInvited.ModifyBy = self.$store.getters[StoreGetter.user].UserID;
          var obj = {
            model: self.candidateInvited,
          }
          if (!self.isEditMode) {
            self.addInvitationData(obj);
          } else {
            self.editInvitationData(obj);
          }
        }
      });
    },
    async addInvitationData(obj) {
      var self = this;
      const response = await InviteNewCandidateService.add(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetInvitationData();
        self.clearPagination();
        self.init();
        await self.getCandidateInvitedList();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async editInvitationData(obj) {
      var self = this;
      const response = await InviteNewCandidateService.update(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetInvitationData();
        self.clearPagination();
        self.init();
        await self.getCandidateInvitedList();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    OnAttachmentOpen: function () {
      var self = this;
      $("#attachmentFile").click();
    },
    onFileChange(e, fieldName, fileList) {
      var self = this;
      if (!fileList.length) return;
      var counter = -1, file;
      while (file = e.target.files[++counter]) {
        const reader = new FileReader();
        reader.onload = (function (file) {
          return function (e1) {
            var path = reader.result ? reader.result.toString() : "";
            self.attachment = new Attachment();
            self.attachment.DocURL = path;
            self.attachment.DocFile = path.indexOf(",") != -1 ? path.split(",").pop() : "";
            self.attachment.DocMime = file.type;
            self.attachment.IsImageFile = path.indexOf("image") != -1 ? true : false;
            self.candidateInvited.AttachmentList.push(self.attachment);
          };
        })(file);
        if (file) {
          reader.readAsDataURL(file);
        }
      }
    },
    onAddButtonClick: function () {
      this.resetInvitationData();
      this.candidateInvited.IsNew = true;
      this.isLoaded = false;
      this.isLoaded = true;
    },
    onEditButtonClick: function () {
      if (this.candidateInvited.CandID != '') {
        this.isEditMode = true;
        this.candidateInvited.IsNew = false;
        this.isLoaded = false;
        this.isLoaded = true;
      }
    },
    resetInvitationData: function () {
      var self = this;
      self.staff = new Staff();
      self.staffList = [];
      self.userExist = false;
      self.dob = "";
      self.existingUserId = "";
      self.isEditMode = false;
      self.selectAllTimes = false;
      self.optionList = [];
      self.candidateInvited = new CandidateInvited();
      self.$validator.reset();
      self.vErrors.clear();
    },
    clearPagination: function () {
      var self = this;
      self.take = 10;
      self.skip = 0;
      self.totalNoOfPages = 0;
      self.noOfPages = 5;
      self.currentSelectedPage = 0;
      self.currentPage = self.currentSelectedPage + 1;
      self.totalRecords = 0;
    },
    deleteAttachmentPopup: function (data) {
      var self = this;
      self.selectedAttachment = new Attachment();
      self.selectedAttachment = data;
      $('#deleteAttachmentModal').modal('show');
    },
    OnAttachmentDeleteClick: function () {
      var self = this;
      self.candidateInvited.AttachmentList.forEach((element, index) => {
        if (element.DocID == self.selectedAttachment.DocID) {
          if (element.DocID == '') {
            self.candidateInvited.AttachmentList.splice(index, 1);
          } else {
            element.IsDeleted = true;
          }
          return;
        }
      });
      self.closeAttachmentPopup();
    },
    closeAttachmentPopup: function () {
      var self = this;
      self.selectedAttachment = new Attachment();
      $('#deleteAttachmentModal').modal('hide');
    },
    cancelInvitationData() {
      var self = this;
      self.resetInvitationData();
    },
    //Pagination Method start
    changePage(pagenumber) {
      this.currentPage = pagenumber;
      this.currentSelectedPage = pagenumber - 1;
      this.setPage();
    },
    setPage() {
      this.skip = this.take * (this.currentPage - 1) - 1;
      if (this.skip != 0) {
        this.skip++;
      }
      this.getCandidateInvitedList();
    },
    totalPages() {
      var numbers = this.totalRecords / this.take;
      var pages = 0;
      if (Number.isInteger(numbers)) {
        pages = numbers;
      } else {
        pages = Math.floor(numbers) + 1;
      }
      this.totalNoOfPages = pages;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/S090000-Candidate/S090200-InviteNewCandidate/S090200-InviteNewCandidate.js